import { render, staticRenderFns } from "./adjustment-case-allot.vue?vue&type=template&id=cdc6ceb6&scoped=true"
import script from "./adjustment-case-allot.vue?vue&type=script&lang=ts"
export * from "./adjustment-case-allot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc6ceb6",
  null
  
)

export default component.exports